import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import '../styles/components/GenericSelector.scss';

export interface SelectorOption<T extends string = string> {
    value: T;
    label: string;
    icon: IconDefinition;
    disabled?: boolean;
}

interface GenericSelectorProps<T extends string> {
    options: SelectorOption<T>[];
    selectedValue: T | null;
    onSelectValue: (value: T) => void;
    className?: string; // Allow passing a custom class for the container
}

const GenericSelector = <T extends string>({
    options,
    selectedValue,
    onSelectValue,
}: GenericSelectorProps<T>) => {
    return (
        <div className={'generic-selector'}>
            {options.map((option) => (
                <div
                    key={option.value}
                    className={`selector-option ${
                        selectedValue === option.value ? 'selected' : ''
                    } ${option.disabled ? 'disabled' : ''}`}
                    onClick={() => {
                        if (!option.disabled) {
                            onSelectValue(option.value);
                        }
                    }}
                    role="button"
                    tabIndex={option.disabled ? -1 : 0}
                    onKeyPress={(e) => {
                        if (
                            !option.disabled &&
                            (e.key === 'Enter' || e.key === ' ')
                        ) {
                            onSelectValue(option.value);
                        }
                    }}
                >
                    <FontAwesomeIcon icon={option.icon} />
                    <span>{option.label}</span>
                </div>
            ))}
        </div>
    );
};

export default GenericSelector;
